export const getUserByAuth0Id = "getUserByAuth0Id";
export const getCurrentUserProfile = "getCurrentUserProfile";
export const getCurrentUsersDevices = "getCurrentUsersDevices";
export const getRelationships = "getRelationships";
export const getSpecialties = "getSpecialties";
export const getShareHistory = "getShareHistory";
export const postShareHistory = "postShareHistory";
export const getLatestReadingsForDevice = "getLatestReadingsForDevice";

// Word Game
export const attemptedWord = "attemptedWord";
export const createWordGame = "createWordGame";
export const getAllGuessedWords = "getAllGuessedWords";
export const getAllWordGameWords = "getAllWordGameWords";
export const getWordGameRecord = "getWordGameRecord";
export const getWordGameWordOfTheDay = "getWordGameWordOfTheDay";
export const saveWordForRow = "saveWordForRow";
export const setWordGameId = "setWordGameId";
export const updateAttemptedGuesses = "updateAttemptedGuesses";
export const updateGameWon = "updateGameWon";
export const updateLettersGuessed = "updateLettersGuessed";
export const updateWordGame = "updateWordGame";
export const updateWordGameStreaks = "updateWordGameStreaks";
